<template>
  <div v-if="model" class="flex min-w-50 flex-col">
    <div class="flex items-center space-x-2">
      <div class="h-5 w-5">
        <icon-base
          :icon="IconActivityHub"
          class="text-flush-orange"
          height="22"
          width="22"
          viewBox="0 0 24 24"
        />
      </div>
      <span
        v-tooltipable
        class="overflow-hidden text-ellipsis whitespace-nowrap text-headline"
      >
        {{ model.body }}
      </span>
    </div>
    <div class="text-label">
      <date-and-time-display
        :value="model?.created_at || ''"
        :show-time-below-date="false"
      />
    </div>
  </div>
  <div v-else>-</div>
</template>
<script setup lang="ts">
import IconActivityHub from "@/components/icons/IconActivityHub.vue";
import IconBase from "@/components/ui/IconBase.vue";
import DateAndTimeDisplay from "@/components/ui/text/DateAndTimeDisplay.vue";

import type { TaskLogData } from "@/models/communicationLogs";

const { model } = defineProps<{ model: TaskLogData }>();
</script>
